import { QuestionCircleOutlined } from '@ant-design/icons'

import { AsinLink } from 'components/Links'
import { ToolTip } from 'components/ToolTip'
import { UNDEFINED_VALUE } from 'const/formatting'
import { isUnset } from 'helpers/utilities'
import { CellRenderProps, Field } from 'types'

import { createField, createTitleField } from './createField'
import { FieldCreatorOptions } from './localTypes'

export function attributionType<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const dataIndex = options.dataIndex ?? ['attribution_type']
    return createTitleField({
        ...options,
        id: 'attribution_type',
        name: 'Attribution Type',
        shortName: 'Attribution Type',
        minWidth: 50,
        dataIndex,
        width: 100,
    })
}

export function productId<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return createField({
        ...options,
        id: options.id ?? 'product_id',
        name: 'ASIN',
        shortName: 'ASIN',
        minWidth: 80,
        dataIndex: options.dataIndex ?? ['product_id'],
        renderOptions: {
            render: ({ value }: CellRenderProps<any>) => {
                if (isUnset(value)) {
                    return <span>{UNDEFINED_VALUE}</span>
                }
                const [countryCode, asin] = value.split('_')
                return <AsinLink asin={asin} countryCode={countryCode} />
            },
        },
        width: 100,
    })
}

export function product_category<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const dataIndex = options.dataIndex ?? ['product_category']
    return createField({
        ...options,
        id: 'product_category',
        name: 'Product Category',
        shortName: 'Category',
        minWidth: 100,
        dataIndex,
        columnTitle: (
            <>
                Product Category{' '}
                <ToolTip title="The number next to the category represents the category ID">
                    <QuestionCircleOutlined />
                </ToolTip>
            </>
        ),
        width: 150,
    })
}
